module.exports = __webpack_public_path__ + "img/Bigscreenfooter.589e91b8.png";